(function () {
    function initTurnkeyService(container) {
        var tabs = Array.prototype.slice.call(
            container.querySelectorAll('[data-turnkey-tab]')
        );
        var panels = Array.prototype.slice.call(
            container.querySelectorAll('[data-turnkey-panel]')
        );
        var tablist = container.querySelector('[data-turnkey-tablist]');
        var indicator = tablist
            ? tablist.querySelector('.archive-filter__indicator')
            : null;

        if (tablist && tabs.length) {
            tablist.classList.add('is-enhanced');
        }

        function moveIndicator(activeTab, shouldAnimate) {
            if (!tablist || !indicator || !activeTab) return;

            var targetWidth = activeTab.offsetWidth;
            var targetX = activeTab.offsetLeft;
            var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            var canUseGsap = typeof window.gsap !== 'undefined';

            tablist.style.setProperty('--indicator-width', targetWidth);
            tablist.style.setProperty('--indicator-x', targetX);

            if (!canUseGsap) return;

            tablist.classList.add('is-gsap');
            window.gsap.killTweensOf(indicator);

            if (!shouldAnimate || prefersReducedMotion) {
                window.gsap.set(indicator, {
                    x: targetX,
                    width: targetWidth,
                    scaleY: 1,
                    borderRadius: '50px'
                });
                return;
            }

            var currentX = Number(window.gsap.getProperty(indicator, 'x')) || 0;
            var distance = targetX - currentX;
            var direction = distance >= 0 ? 1 : -1;
            var stretch = Math.min(Math.max(Math.abs(distance) * 0.14, 14), 40);
            var stretchedX = currentX + distance * 0.46
                - (direction < 0 ? stretch : 0);
            var settlingX = targetX
                - (direction > 0 ? stretch * 0.18 : stretch * 0.3);
            var liquidShape = direction > 0
                ? '52% 100% 100% 52% / 50% 16% 84% 50%'
                : '100% 52% 52% 100% / 16% 50% 50% 84%';
            var settlingShape = direction > 0
                ? '50% 78% 78% 50% / 50% 30% 70% 50%'
                : '78% 50% 50% 78% / 30% 50% 50% 70%';
            var travelDuration = Math.min(
                0.32,
                0.16 + Math.abs(distance) / 1400
            );

            window.gsap.timeline()
                .to(indicator, {
                    x: stretchedX,
                    width: targetWidth + stretch,
                    scaleY: 0.86,
                    borderRadius: liquidShape,
                    duration: travelDuration,
                    ease: 'power2.in'
                })
                .to(indicator, {
                    x: settlingX,
                    width: targetWidth + stretch * 0.45,
                    scaleY: 0.95,
                    borderRadius: settlingShape,
                    duration: 0.2,
                    ease: 'sine.inOut'
                })
                .to(indicator, {
                    x: targetX,
                    width: targetWidth,
                    scaleY: 1,
                    borderRadius: '50px',
                    duration: 0.42,
                    ease: 'elastic.out(1, 0.72)'
                });
        }

        function animatePanel(panel, direction) {
            if (
                !panel
                || typeof window.gsap === 'undefined'
                || window.matchMedia('(prefers-reduced-motion: reduce)').matches
            ) {
                return;
            }

            var panelParts = Array.prototype.slice.call(panel.children);
            if (!panelParts.length) return;

            window.gsap.killTweensOf(panelParts);
            window.gsap.fromTo(
                panelParts,
                {
                    opacity: 0,
                    x: direction * 24
                },
                {
                    opacity: 1,
                    x: 0,
                    duration: 0.55,
                    stagger: 0.06,
                    ease: 'power3.out',
                    clearProps: 'opacity,transform'
                }
            );
        }

        function pausePanelVideos(activePanel) {
            panels.forEach(function (panel) {
                if (panel === activePanel) return;

                var video = panel.querySelector('[data-turnkey-video]');
                if (video) video.pause();
            });
        }

        function activateTab(tab, moveFocus) {
            var panelId = tab.getAttribute('aria-controls');
            var activePanel = panelId ? document.getElementById(panelId) : null;
            var previousIndex = tabs.findIndex(function (item) {
                return item.getAttribute('aria-selected') === 'true';
            });
            var nextIndex = tabs.indexOf(tab);
            var direction = nextIndex >= previousIndex ? 1 : -1;

            tabs.forEach(function (item) {
                var isActive = item === tab;
                item.classList.toggle('is-active', isActive);
                item.setAttribute('aria-selected', isActive ? 'true' : 'false');
                item.setAttribute('tabindex', isActive ? '0' : '-1');
            });

            panels.forEach(function (panel) {
                panel.hidden = panel !== activePanel;
            });

            pausePanelVideos(activePanel);
            moveIndicator(tab, true);
            animatePanel(activePanel, direction);

            if (moveFocus) tab.focus();
        }

        tabs.forEach(function (tab, index) {
            tab.addEventListener('click', function () {
                if (tab.getAttribute('aria-selected') === 'true') return;

                activateTab(tab, false);
            });

            tab.addEventListener('keydown', function (event) {
                var nextIndex = index;

                if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
                if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
                if (event.key === 'Home') nextIndex = 0;
                if (event.key === 'End') nextIndex = tabs.length - 1;

                if (nextIndex === index) return;

                event.preventDefault();
                activateTab(tabs[nextIndex], true);
            });
        });

        container.querySelectorAll('[data-turnkey-play]').forEach(function (button) {
            button.addEventListener('click', function () {
                var media = button.closest('.about-us__turnkey-media');
                var video = media ? media.querySelector('[data-turnkey-video]') : null;

                if (!video) return;

                video.controls = true;
                var playPromise = video.play();

                if (playPromise && typeof playPromise.then === 'function') {
                    playPromise.then(function () {
                        media.classList.add('is-playing');
                    }).catch(function () {
                        video.controls = false;
                    });
                } else {
                    media.classList.add('is-playing');
                }
            });
        });

        if (tabs.length) {
            var activeTab = tabs.find(function (tab) {
                return tab.getAttribute('aria-selected') === 'true';
            }) || tabs[0];

            moveIndicator(activeTab, false);

            window.addEventListener('resize', function () {
                var currentTab = tabs.find(function (tab) {
                    return tab.getAttribute('aria-selected') === 'true';
                }) || tabs[0];

                moveIndicator(currentTab, false);
            });

            if (document.fonts && document.fonts.ready) {
                document.fonts.ready.then(function () {
                    var currentTab = tabs.find(function (tab) {
                        return tab.getAttribute('aria-selected') === 'true';
                    }) || tabs[0];

                    moveIndicator(currentTab, false);
                });
            }
        }
    }

    function init() {
        document.querySelectorAll('[data-turnkey-tabs]').forEach(initTurnkeyService);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
